import { Directive } from '@angular/core';
import { BrnTooltipTrigger, provideBrnTooltipDefaultOptions } from '@spartan-ng/brain/tooltip';

export const DEFAULT_TOOLTIP_CONTENT_CLASSES =
	'bg-popover text-popover-foreground border shadow-sm animate-in fade-in-0 zoom-in-95 z-50 w-fit rounded px-2 py-1 text-xs ' +
	'data-[state=open]:animate-in ' +
	'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 ' +
	'data-[side=below]:slide-in-from-top-2 data-[side=above]:slide-in-from-bottom-2 ' +
	'data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 ';

@Directive({
	selector: '[hlmTooltipTrigger]',
	providers: [
		provideBrnTooltipDefaultOptions({
			showDelay: 0,
			hideDelay: 0,
			exitAnimationDuration: 100,
			position: 'right',
			tooltipContentClasses: DEFAULT_TOOLTIP_CONTENT_CLASSES,
		}),
	],
	hostDirectives: [
		{
			directive: BrnTooltipTrigger,
			inputs: [
				'brnTooltipDisabled: hlmTooltipDisabled',
				'brnTooltipTrigger: hlmTooltipTrigger',
				'aria-describedby',
				'position',
				'positionAtOrigin',
				'hideDelay',
				'showDelay',
				'exitAnimationDuration',
				'touchGestures',
				'tooltipContentClasses',
			],
		},
	],
})
export class HlmTooltipTrigger {}
